<template>
  <b-modal ref="modal" title="Immobile nucleo familiare" size="lg" no-close-on-backdrop>
    <div class="row">

      <div role="group" class="col-12 col-md-6 stack-label">
        <label>comune</label>
        <div>
          <b-dropdown :text="`${immobile.descrizioneComune} (${immobile.provincia})`" variant="outline" no-caret size="sm"
            class="w-100 btn-left" style="border:1px solid #ccc;padding:0px;min-height:2rem;" @show="onShowSearchComune">
            <b-dropdown-header class="p-1" @click.stop>
              <b-input ref="searchComune" v-model="searchComune" type="text" size="sm" style="width:20rem" placeholder="Inserire testo per ricerca comune..."/>
            </b-dropdown-header>
            <b-dropdown-item-button v-for="o in comuneOptions" :key="o.codice"
              class="small text-italic" @click="selectComune(o)">{{o.descrizione}} ({{o.provincia}})</b-dropdown-item-button>
            <b-dropdown-header v-if="searchComune && !comuneOptions.length" class="small">Nessuna corrispondenza...</b-dropdown-header>
          </b-dropdown>
        </div>
      </div>

      <div role="group" class="col-12 col-md-6 stack-label">
        <label>indirizzo</label>
        <b-input v-model.trim="immobile.indirizzo" type="text" :formatter="formatUcase" size="sm" :state="fieldState('indirizzo')"/>
        <b-form-invalid-feedback v-if="!$v.immobile.indirizzo.required">Campo obbligatorio</b-form-invalid-feedback>
      </div>

      <div role="group" class="col-12 col-md-3 stack-label">
        <label>tipologia immobile</label>
        <b-form-select v-model="immobile.codiceTipoImmobile" :options="tipoImmobileOptions" size="sm" :state="fieldState('codiceTipoImmobile')"/>
        <b-form-invalid-feedback v-if="!$v.immobile.codiceTipoImmobile.required">Campo obbligatorio</b-form-invalid-feedback>
      </div>

      <div role="group" class="col-12 col-md-3 stack-label">
        <label>superficie netta (mq)</label>
        <b-input v-model="immobile.superficieNetta" type="number" size="sm" :state="fieldState('superficieNetta')"/>
        <b-form-invalid-feedback v-if="!$v.immobile.superficieNetta.minValue">Il valore deve essere positivo</b-form-invalid-feedback>
      </div>

      <div role="group" class="col-12 col-md-3 stack-label">
        <label>% titolarità</label>
        <b-input v-model="immobile.percTitolarita" type="number" size="sm" :state="fieldState('percTitolarita')"/>
        <b-form-invalid-feedback v-if="!$v.immobile.percTitolarita.required">Campo obbligatorio</b-form-invalid-feedback>
        <b-form-invalid-feedback v-if="!$v.immobile.percTitolarita.between">Il valore deve essere fra 0 e 100</b-form-invalid-feedback>
      </div>

      <div role="group" class="col-12 col-md-3 stack-label">
        <label>rendita</label>
        <b-input v-model="immobile.rendita" type="number" size="sm" :state="fieldState('rendita')"/>
        <b-form-invalid-feedback v-if="!$v.immobile.rendita.required">Campo obbligatorio</b-form-invalid-feedback>
        <b-form-invalid-feedback v-if="!$v.immobile.rendita.minValue">Il valore deve essere positivo</b-form-invalid-feedback>
      </div>

      <div class="col-12 px-3">
        <div
          class="mb-2 font-weight-bold text-uppercase mt-3 text-muted text-left"
          style="font-size:.9rem; border-bottom:1px solid #ddd"
        >
          Dati identificatvi catastali:
        </div>
      </div>

      <div role="group" class="col-12 col-md-4 stack-label">
        <label>foglio</label>
        <b-input v-model="immobile.foglio" type="text" size="sm" :state="fieldState('foglio')"/>
        <b-form-invalid-feedback v-if="!$v.immobile.foglio.required">Campo obbligatorio</b-form-invalid-feedback>
        <b-form-invalid-feedback v-if="!$v.immobile.foglio.catastatoField">Caratteri immessi non validi</b-form-invalid-feedback>
      </div>

      <div role="group" class="col-12 col-md-4 stack-label">
        <label>numero</label>
        <b-input v-model="immobile.numero" type="text" size="sm" :state="fieldState('numero')"/>
        <b-form-invalid-feedback v-if="!$v.immobile.numero.required">Campo obbligatorio</b-form-invalid-feedback>
        <b-form-invalid-feedback v-if="!$v.immobile.numero.catastatoField">Caratteri immessi non validi</b-form-invalid-feedback>
      </div>

      <div role="group" class="col-12 col-md-4 stack-label">
        <label>subalterno</label>
        <b-input v-model="immobile.subalterno" type="text" size="sm" :state="fieldState('subalterno')"/>
        <b-form-invalid-feedback v-if="!$v.immobile.subalterno.catastatoField">Caratteri immessi non validi</b-form-invalid-feedback>
      </div>

      <div role="group" class="col-12 col-md-4 stack-label">
        <label>categoria</label>
        <b-input v-model="immobile.categoria" type="text" size="sm" :state="fieldState('categoria')"/>
        <b-form-invalid-feedback v-if="!$v.immobile.categoria.catastatoField">Caratteri immessi non validi</b-form-invalid-feedback>
      </div>
    </div>

    <template slot="modal-footer">

      <b-button v-if="idx===-1" variant="success" @click="add">
        <font-awesome-icon icon="plus"/> Aggiungi
      </b-button>

      <b-button v-else variant="success" @click="update">
        <font-awesome-icon icon="edit"/> Aggiorna
      </b-button>

      <b-button v-if="idx!==-1" variant="danger" @click="remove">
        <font-awesome-icon icon="trash-alt" class="mr-2"/> Rimuovi immobile
      </b-button>

      <b-button variant="outline-secondary" @click="close">
        <font-awesome-icon icon="times" class="mr-2"/> Annulla
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { required, between, minValue } from 'vuelidate/lib/validators'
import debounce from 'lodash/debounce'
import cloneDeep from 'lodash/cloneDeep'

const catastatoField = (value, vm) => {
  let retValue = false

  // console.log('lunghezza stringa :', Object.keys(value).length)
  if (Object.keys(value).length <= 5) {
    retValue = true
  }

  return retValue
}

export default {
  name: 'ImmobileModal',

  data () {
    return {
      idx: -1,
      item: {},
      immobile: this.emptyImmobile(),
      searchComune: '',
      searchComuneHandler: debounce(async () => { await this.lookupComune() }, 500)
    }
  },

  validations: {
    immobile: {
      codiceComune: { required },
      indirizzo: { required },
      percTitolarita: { required, between: between(0, 100) },
      codiceTipoImmobile: { required },
      superficieNetta: { minValue: minValue(0) },
      rendita: { required, minValue: minValue(0) },
      // I campi foglio, numero e subalterno non sono obbligatori.
      // foglio: { required, catastatoField },
      // numero: { required, catastatoField },
      foglio: { required, catastatoField },
      numero: { required, catastatoField },
      subalterno: { catastatoField },
      categoria: { catastatoField }
    }
  },

  computed: {
    tipoImmobileOptions () {
      return this.$store.state.options.tipoImmobile
    },
    comuneOptions () {
      return this.$store.state.lookups.comune.items
    }
  },

  watch: {
    searchComune (newVal, oldVal) {
      this.searchComuneHandler()
    }
  },

  methods: {
    emptyImmobile () {
      return {
        indirizzo: '',
        codiceComune: '',
        descrizioneComune: '',
        provincia: '',
        percTitolarita: '',
        rendita: '',
        codiceTipoImmobile: '',
        foglio: '',
        numero: '',
        subalterno: '',
        categoria: ''
      }
    },

    fieldState (field) {
      let v = this.$v.immobile[field]
      return v.$dirty && v.$error ? false : null
    },

    open ({ item, idx }) {
      this.$v.$reset()
      this.item = item
      this.idx = idx >= 0 ? idx : -1
      this.immobile = idx >= 0 ? cloneDeep(item.immobili[idx]) : this.emptyImmobile()
      this.searchComune = ''
      this.$refs.modal.show()
    },

    close () {
      this.$refs.modal.hide()
    },

    async lookupComune () {
      await this.$store.dispatch('lookups/lookupComune', this.searchComune)
    },

    selectComune (comune) {
      this.immobile.codiceComune = comune.codice
      this.immobile.descrizioneComune = comune.descrizione
      this.immobile.provincia = comune.provincia
    },

    onShowSearchComune () {
      this.$nextTick(() => this.$refs.searchComune.$el.focus())
    },

    async validate () {
      let idRet = null
      this.$v.$touch()
      idRet = !this.$v.$invalid

      // Verificare che i dati dei titolare siano coerenti con quanto presente nella base dati (CODICE RU e BU + CF)
      // console.log('dichiarazioni/checkImmobile', this.immobile)
      let checkValue = true

      if (this.immobile.codiceComune === 'H501') {
        let immobileChecked = await this.$store.dispatch('dichiarazioni/checkImmobile', this.immobile)
        // console.log('immobileChecked', immobileChecked, idRet)
        checkValue = (immobileChecked.result_out !== 0 ? false : immobileChecked.esito_out === 'P')
      }

      idRet = idRet && checkValue
      // console.log('validate', idRet)

      return { value: idRet, description: checkValue ? '' : 'Verificare dati catastali immobile!' }
    },

    async add () {
      let validate = await this.validate()
      if (!validate.value) {
        this.$ui.notify({
          type: 'warning',
          title: 'Attenzione',
          message: 'I dati inseriti non sono corretti.'
        })
      } else {
        // console.log('prima della push', this.item.immobili)
        if (!this.item.immobili) this.$set(this.item, 'immobili', [this.immobile])
        else this.item.immobili.push(this.immobile)
        // fine - Funzionerebbe anche, ma non si visualizza nulla al primo inserimento
        // this.item.immobili.push(this.immobile)
        // console.log('dopo la push', this.item.immobili)
        this.close()
      }
    },

    async update () {
      let validate = await this.validate()
      // console.log('update validateValue', validate)
      if (!validate.value) {
        this.$ui.notify({
          type: 'warning',
          title: 'Attenzione',
          message: `I dati inseriti non sono corretti. ${!validate.value ? validate.description : ''}`
        })
      } else {
        this.$set(this.item.immobili, this.idx, this.immobile)
        this.close()
      }
    },

    remove () {
      this.item.immobili.splice(this.idx, 1)
      this.close()
    },
    formatUcase (value, event) {
      return value.toUpperCase()
    }
  }
}
</script>

<style lang="stylus" scoped>
.btn-left >>> button {
  text-align: left !important;
}
</style>
